export const getProduct = (detailsState) => {
    const productResponse = detailsState?.response?.body;

    return productResponse?.products.find(({ displayable, banned }) => displayable && !banned);
};
